export const getRentalPropertyInputs = (buildingOptions = []) => {
  return [
    {
      _key: "property_name",
      _name: "Property Name",
      _value: "",
      _type: "text",
      _placeholder: "Property Name",
      _helperText: "Please enter Property Name",
      _mandatory: true,
      _errorMsg: "",
      _gridSize: 6,
    },
    {
      _key: "building_id",
      _name: "Building",
      _value: "",
      _type: "drop-down",
      _placeholder: "Select Building",
      _helperText: "Please select building",
      _mandatory: true,
      _options: {
        options: buildingOptions,
      },
      _gridSize: 12,
    },
    {
      _key: "property_address",
      _name: "Property Address",
      _value: "",
      _type: "text",
      _placeholder: "Property Address",
      _helperText: "Please enter Property Address",
      _mandatory: true,
      _options: {},
      _gridSize: 12,
    },
  ];
};
